import { RouteV2Id } from 'routes/routesConfigV2';
import { QuoteChecklistCard } from 'types/enrollmentService';

export const QUOTE_CHECKLIST_MAPPING: Record<QuoteChecklistCard, RouteV2Id> = {
  [QuoteChecklistCard.INITIATE_SHELF]: RouteV2Id.QUOTE_PROPOSAL_INFO,
  [QuoteChecklistCard.INITIATE_SHELF_ADD_EMPLOYEES]: RouteV2Id.QUOTE_ADD_EMPLOYEES,
  [QuoteChecklistCard.IMQ_ADD_EMPLOYEES]: RouteV2Id.IMQ_ADD_EMPLOYEES,
  [QuoteChecklistCard.INITIATE_SHELF_ADD_QUOTE]: RouteV2Id.INITIATE_SHELF_ADD_QUOTE,
  /**
   * Existing prod checklists still return INITIATE_SHELF_BROWSING instead of INITIATE_SHELF_ADD_QUOTE for old checklists.
   * Keep handling this card so those checklists work, but always send users to the Add Quote page.
   */
  [QuoteChecklistCard.INITIATE_SHELF_BROWSING]: RouteV2Id.INITIATE_SHELF_ADD_QUOTE,
  [QuoteChecklistCard.ZYWAVE_QUOTE_REDIRECT]: RouteV2Id.ZYWAVE_QUOTE_REDIRECT,
  [QuoteChecklistCard.DOWNLOAD_IMQS]: RouteV2Id.DOWNLOAD_IMQS,
};
